<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>ESG Standards</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCreateCsrStandard()">
        <mat-icon>add</mat-icon>
        Add ESG Standard
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="csrStandards()"
      [columns]="csrStandardsColumns"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditCsrStandard($event)"
      (deleteClick)="onDeleteCsrStandard($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
